<template>
  <div
    style="
      background-color: rgba(52, 59, 64, 0.5) !important;
      padding: 3px 10px;
      border-radius: 25px;
      border: 1px solid rgb(100, 100, 100);
    "
  >
    <button
      v-for="language in languages"
      :key="language.lang"
      @click="changeLang(language.lang)"
      :style="[
        langAvailable.includes(language.lang)
          ? { cursor: 'pointer' }
          : { cursor: 'default' }
      ]"
    >
      <flag
        :iso="language.flag"
        :style="[language.lang === clang ? { opacity: 0.8 } : { opacity: 0.2 }]"
      />
    </button>
  </div>
</template>

<script>
import { loadLanguageAsync, language } from '@/plugins/i18n'
import { useCoreStore } from '@/stores/core'

export default {
  name: 'LanguageSwitcher',
  data: function () {
    return {
      languages: [
        {
          flag: 'FR',
          lang: 'fr',
          title: 'Français'
        },
        {
          flag: 'GB',
          lang: 'en',
          title: 'English'
        }
      ],
      clang: language
    }
  },
  setup () {
    let coreStore = useCoreStore()
    return { coreStore }
  },
  computed: {
    filteredLanguage: function () {
      return this.languages.filter((item) => {
        if (this.langAvailable.includes(item.lang)) {
          return true
        } else {
          return false
        }
      })
    },
    langAvailable: function () {
      var langA = ['fr', 'en']
      return langA
    }
  },
  methods: {
    changeLang (lang) {
      loadLanguageAsync(lang).then((lang) => {
        if (this.langAvailable.includes(lang)) {
          localStorage.setItem('language', lang)
          this.$i18n.locale = lang
          this.clang = lang
          this.coreStore.i18nOverrides()
        }
      })
    }
  },
  watch: {
    'i18n.locale': function (lang) {
      if (lang !== this.clang) {
        this.clang = lang
      }
    },
    langAvailable: function () {
      if (!this.langAvailable.includes(this.clang)) {
        this.clang = 'fr'
        this.$i18n.locale = 'fr'
      }
    }
  }
}
</script>

<style lang="css">
button {
  background: none;
  padding-right: 5px;
  padding-left: 5px;
  border: 0px;
  font-size: 16px;
  margin: 0px;
  cursor: pointer;
}
</style>
